import type { KeyboardEventHandler, PropsWithChildren } from "react";

import { cn } from "../../../utils";
import { Text } from "../Text";

interface ILabelProps {
  htmlFor?: string;
  className?: string;
  disabled?: boolean;
  tabIndex?: number;
  onClick?: () => void;
  onKeyDown?: KeyboardEventHandler<HTMLElement>;
}

export const Label = ({
  children,
  htmlFor,
  className,
  disabled,
  tabIndex,
  onClick,
  onKeyDown,
}: PropsWithChildren<ILabelProps>) => {
  return (
    <Text
      htmlTag="label"
      tabIndex={tabIndex}
      size="sm"
      className={cn(
        "inline-block font-semibold leading-6 m-0",
        className,
      )}
      aria-disabled={disabled}
      htmlFor={htmlFor}
      onClick={onClick}
      onKeyDown={onKeyDown}
    >
      {children}
    </Text>
  );
};
